import * as Styled from './index.styles';

const LockedClientRowPlaceholder = () => {
  return (
    <Styled.Row>
      <Styled.Dot />
      <Styled.InfoSection>
        <Styled.Bar width={120} />
        <Styled.Bar width={180} />
      </Styled.InfoSection>
    </Styled.Row>
  );
};

export default LockedClientRowPlaceholder;
